import './header.css'

const Header = () => {
  return (
    <header className="man__header">
      <div className="main__header-container">
        <div className="man__header-left">
          <h1>OUR SERVICES</h1>
        </div>
      </div>
    </header>
  )
}

export default Header